var Location = /** @class */ (function () {
    function Location(init) {
        this.id = -1;
        this.firstName = '';
        this.lastName = '';
        this.company = '';
        this.street = '';
        this.street2 = '';
        this.city = '';
        this.state = '';
        this.zip = '';
        this.apartment = "No";
        this.floors = "1";
        this.own = "No";
        this.pets = "No";
        this.securityGate = "No";
        this.color = '';
        this.directions = '';
        this.mount = 1;
        Object.assign(this, init);
    }
    return Location;
}());
export { Location };
var Contact = /** @class */ (function () {
    function Contact(init) {
        this.firstName = '';
        this.lastName = '';
        this.email = '';
        this.phone = '';
        this.textReminder = 'No';
        this.instructions = '';
        Object.assign(this, init);
    }
    return Contact;
}());
export { Contact };
var Schedule = /** @class */ (function () {
    function Schedule() {
        this.serviceEventId = '';
        this.availability = '';
        this.scheduleNotes = '';
        this.leadDays = -1;
        this.scheduleDate = new Date().toLocaleDateString();
        this.minDate = new Date().toLocaleDateString();
    }
    return Schedule;
}());
export { Schedule };
